import { render, staticRenderFns } from "./NumCompare.vue?vue&type=template&id=4721e2c1"
import script from "./NumCompare.vue?vue&type=script&lang=js"
export * from "./NumCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports